import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgLocationPin = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M8.34717 8.88099C8.34717 9.75031 8.6925 10.584 9.30721 11.1987C9.92191 11.8134 10.7556 12.1588 11.6249 12.1588C12.4943 12.1588 13.328 11.8134 13.9427 11.1987C14.5574 10.584 14.9027 9.75031 14.9027 8.88099C14.9027 8.01167 14.5574 7.17795 13.9427 6.56325C13.328 5.94855 12.4943 5.60321 11.6249 5.60321C10.7556 5.60321 9.92191 5.94855 9.30721 6.56325C8.6925 7.17795 8.34717 8.01167 8.34717 8.88099V8.88099Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.625 1.50589C13.581 1.50589 15.4568 2.2829 16.8399 3.66598C18.223 5.04906 19 6.92492 19 8.88089C19 12.4329 13.3928 20.3826 11.9571 22.3602C11.9189 22.4124 11.8689 22.4548 11.8112 22.484C11.7535 22.5133 11.6897 22.5285 11.625 22.5285C11.5603 22.5285 11.4965 22.5133 11.4388 22.484C11.3811 22.4548 11.3311 22.4124 11.2929 22.3602C9.85718 20.3826 4.25 12.4329 4.25 8.88089C4.25 6.92492 5.02701 5.04906 6.41009 3.66598C7.79317 2.2829 9.66903 1.50589 11.625 1.50589Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgLocationPin.displayName = 'SvgLocationPin';
export default SvgLocationPin;
